const v = "5.5.7";
const meta = {
	g: "LottieFiles AE 0.1.21",
	a: "SCDesign Eddy",
	k: "",
	d: "SCB Success Tick",
	tc: "Dark Theme"
};
const fr = 60;
const ip = 1;
const op = 120;
const w = 1125;
const h = 1125;
const nm = "3.20.7 copy";
const ddd = 0;
const assets = [
];
const layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Exclamation",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 50,
						s: [
							0
						]
					},
					{
						t: 90,
						s: [
							100
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					562.5,
					562.5,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					562.5,
					562.5,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 30,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 90,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										7.582,
										24.755
									],
									[
										-7.399,
										24.755
									],
									[
										-10.688,
										-23.477
									],
									[
										-10.688,
										-69.333
									],
									[
										10.871,
										-69.333
									],
									[
										10.871,
										-23.477
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 1,
						ty: "sh",
						ix: 2,
						ks: {
							a: 0,
							k: {
								i: [
									[
										3.897,
										0
									],
									[
										2.558,
										2.375
									],
									[
										0,
										3.776
									],
									[
										-2.558,
										2.438
									],
									[
										-3.777,
										0
									],
									[
										-2.438,
										-2.435
									],
									[
										0,
										-3.896
									],
									[
										2.435,
										-2.375
									]
								],
								o: [
									[
										-3.777,
										0
									],
									[
										-2.558,
										-2.375
									],
									[
										0,
										-3.896
									],
									[
										2.558,
										-2.435
									],
									[
										3.897,
										0
									],
									[
										2.435,
										2.438
									],
									[
										0,
										3.776
									],
									[
										-2.438,
										2.375
									]
								],
								v: [
									[
										0.091,
										69.333
									],
									[
										-9.409,
										65.772
									],
									[
										-13.246,
										56.544
									],
									[
										-9.409,
										47.044
									],
									[
										0.091,
										43.391
									],
									[
										9.592,
										47.044
									],
									[
										13.246,
										56.544
									],
									[
										9.592,
										65.772
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 2",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "mm",
						mm: 1,
						nm: "Merge Paths 1",
						mn: "ADBE Vector Filter - Merge",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.999998863071,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								562.684,
								555.541
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 6,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "First Circ",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					562.5,
					562.5,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					129,
					129,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								0.99,
								0.99,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 0,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 60,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-71.097,
										0
									],
									[
										0,
										-71.097
									],
									[
										71.098,
										0
									],
									[
										0,
										71.097
									]
								],
								o: [
									[
										71.098,
										0
									],
									[
										0,
										71.097
									],
									[
										-71.097,
										0
									],
									[
										0,
										-71.097
									]
								],
								v: [
									[
										0,
										-128.734
									],
									[
										128.733,
										0
									],
									[
										0,
										128.733
									],
									[
										-128.733,
										0
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.2840757183,
								0.545545630362,
								0.936088352577,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								128.983,
								128.983
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "Second Circ",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								0.99
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 10,
						s: [
							0
						]
					},
					{
						t: 70,
						s: [
							100
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					562.5,
					562.5,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					208,
					208,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								0.99,
								0.99,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 10,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 70,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-114.638,
										0
									],
									[
										0,
										-114.638
									],
									[
										114.638,
										0
									],
									[
										0,
										114.638
									]
								],
								o: [
									[
										114.638,
										0
									],
									[
										0,
										114.638
									],
									[
										-114.638,
										0
									],
									[
										0,
										-114.638
									]
								],
								v: [
									[
										0,
										-207.571
									],
									[
										207.57,
										0.001
									],
									[
										0,
										207.57
									],
									[
										-207.57,
										0.001
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.2840757183,
								0.545545630362,
								0.936088352577,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 30,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								207.82,
								207.82
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "Third Circ",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								1.01
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 20,
						s: [
							0
						]
					},
					{
						t: 80,
						s: [
							100
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					562.5,
					562.5,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					278,
					278,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 20,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 80,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-153.283,
										0
									],
									[
										0,
										-153.283
									],
									[
										153.283,
										0
									],
									[
										0,
										153.284
									]
								],
								o: [
									[
										153.283,
										0
									],
									[
										0,
										153.284
									],
									[
										-153.283,
										0
									],
									[
										0,
										-153.283
									]
								],
								v: [
									[
										0,
										-277.544
									],
									[
										277.544,
										0
									],
									[
										0,
										277.544
									],
									[
										-277.544,
										0
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.2840757183,
								0.545545630362,
								0.936088352577,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 20,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								277.794,
								277.794
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "Fourth Circ",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.005
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 30,
						s: [
							0
						]
					},
					{
						t: 90,
						s: [
							100
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					562.5,
					562.5,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					346.5,
					346.5,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 30,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 90,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-190.978,
										0
									],
									[
										0,
										-190.977
									],
									[
										190.978,
										0
									],
									[
										0,
										190.977
									]
								],
								o: [
									[
										190.978,
										0
									],
									[
										0,
										190.977
									],
									[
										-190.978,
										0
									],
									[
										0,
										-190.977
									]
								],
								v: [
									[
										0,
										-345.795
									],
									[
										345.795,
										0
									],
									[
										0,
										345.795
									],
									[
										-345.795,
										0
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.2840757183,
								0.545545630362,
								0.936088352577,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 10,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								346.045,
								346.045
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	}
];
const markers = [
];
const aniD2 = {
	v: v,
	meta: meta,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

export { assets, ddd, aniD2 as default, fr, h, ip, layers, markers, meta, nm, op, v, w };
